import { AsyncHelper } from 'src/app/helpers/async.helper';
import { ILauncher } from './launcher.interface';
import { WindowsManagerService } from "../../../services/os/windows-manager.service";
import { IframeContentComponent } from 'src/app/components/desktop/window-contents/iframe-content/iframe-content.component';
import { IFrameData } from 'src/app/components/desktop/window-contents/iframe-content/iframe-data.interface';
import { IFile } from 'src/app/interfaces/io/file.interface';
import { ILaunchSettings } from 'src/app/interfaces/io/launch-settings.interface';
import { VfmService } from '../../io/vfm.service';

export class IframeLauncher implements ILauncher {
  constructor(
    private windowsMgr: WindowsManagerService,
    private vfm: VfmService
    ) {
  }

  async launch(file: IFile, path: string, settings?: ILaunchSettings): Promise<number> {
    const content = await this.vfm.readTextFile(path);
    const data = JSON.parse(content) as IFrameData;

    await AsyncHelper.wait(1000);

    const window = this.windowsMgr.createWindow(data.title, file.icon);

    window.content = {
      component: IframeContentComponent,
      data
    };

    this.windowsMgr.addWindow(window);

    return window.id;
  }
}
